<template>
  <div class="page-canvas">
    <div class="page-root">
      <div class="cadastro-card">
        <div class="cadastro-intro">
          <div class="cadastro-intro__icon-wrap">
            <v-icon color="#0052A0" size="24">mdi-domain-plus</v-icon>
          </div>
          <div>
            <div class="cadastro-intro__title">Cadastre seu credor</div>
            <div class="cadastro-intro__sub">
              Leva poucos minutos: informe seus dados, endereço e documentos para começar a negativar dívidas com segurança.
              Escolha abaixo se o cadastro é de uma empresa (Pessoa Jurídica) ou no seu próprio CPF (Pessoa Física).
            </div>
          </div>
        </div>

        <v-tabs color="#0052A0" grow v-model="tabs" class="cadastro-tabs">
          <v-tab :key="0">Pessoa Jurídica</v-tab>
          <v-tab :key="1">Pessoa Física</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabs">
          <v-tab-item key="pj" class="pt-6">
            <form-pj-component></form-pj-component>
          </v-tab-item>
          <v-tab-item key="pf" class="pt-6">
            <form-pf-component></form-pf-component>
          </v-tab-item>
        </v-tabs-items>

        <div class="cadastro-voltar">
          <v-btn text rounded color="grey darken-1" @click="voltarListEmpresa()">
            <v-icon left small>mdi-arrow-left</v-icon>Voltar<span class="d-none d-sm-inline">&nbsp;para a lista de credores</span>
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormPfComponent from "./FormPfComponent.vue";
import FormPjComponent from "./FormPjComponent.vue";

export default {
  components: { FormPjComponent, FormPfComponent },
 
  data: () => ({
    tabs: 0,
  }),
   mounted() {
    this.id_empresa = this.$route.params.empresa_id ?? null;
    if (this.id_empresa  ) {
     this.tabs = this.$route.params.tipo_fj == "0" ? 1 : 0;
    }
  },

  methods: {
    voltarListEmpresa() {
      this.$router.push({
        name: "Cadastro de Credores",
      });
    },
    getEtapa() {
      this.$http.get("getEtapa").then(
        (response) => {
          this.list = response.data.data;
          this.pagination = response.data;
        },
        (response) => {
          console.log(response);
          // error callback
        }
      );
    },
  },
};
</script>

<style scoped>
.page-canvas {
  background: #eef1f6;
  min-height: calc(100vh - 64px);
  width: 100%;
  box-sizing: border-box;
}

.page-root {
  padding: 28px 32px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}

.cadastro-card {
  width: 100%;
  max-width: 1160px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(16, 24, 40, .06), 0 8px 24px rgba(16, 24, 40, .04);
  padding: 32px 36px 28px;
  box-sizing: border-box;
}

.cadastro-intro {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 28px;
}

.cadastro-intro__icon-wrap {
  width: 40px;
  height: 40px;
  background: #e8f0fe;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.cadastro-intro__title {
  font-family: 'Inter', sans-serif;
  font-size: 1.15rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 4px;
}

.cadastro-intro__sub {
  font-family: 'Inter', sans-serif;
  font-size: 0.85rem;
  color: #64748b;
  line-height: 1.5;
}

.cadastro-tabs {
  border-bottom: 1px solid #f1f5f9;
}

.cadastro-voltar {
  display: flex;
  justify-content: center;
  padding-top: 24px;
}

@media (max-width: 1100px) {
  .page-root { padding: 20px 16px; }
  .cadastro-card { padding: 24px 20px; }
}

@media (max-width: 768px) {
  .page-root { padding: 16px; }
  .cadastro-card { padding: 20px; border-radius: 14px; }
}

@media (max-width: 600px) {
  .page-root { padding: 12px; }
  .cadastro-card { padding: 16px; }
  /* as duas abas precisam caber lado a lado em 360px */
  .cadastro-tabs >>> .v-tab {
    min-width: 0;
    padding: 0 6px;
    font-size: 0.78rem;
    letter-spacing: 0;
  }
}
</style>
